import React, { useRef } from 'react';
import {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from "react-router-dom";
import { Alert, Button, Library, Modal, SelectionInput, SongList, Spinner } from "player-components";

import {ExclamationIcon, AdjustmentsIcon} from '@heroicons/react/solid';
import { fetchLibrarySongsAsync, selectLibrarySongs, selectLibraryStatus } from '../../features/library/librarySlice';

import { createSessionFromSong, selectSetlistSessions, selectLastCreatedSession, resetLastCreated } from '../../features/setlist/setlistSlice';
import { addSongToSetlist, selectSetlistsSetlists, createSetlistFromData } from '../../features/setlists/setlistsSlice'
import {fetchLyricsAsync, resetLyrics, selectLyricsLyrics, selectLyricsStatus} from '../../features/lyrics/lyricsSlice';
import { addNotificationAsync, selectClientConfig, selectOfflineModalVisible, setOfflineModalVisible } from '../../features/ui/uiSlice';
import { openSession, unmountSessionAsync } from "../../features/session/sessionSlice";
import platform from 'platform';
import SetlistsSearch from '../../components/SetlistsSearch';
import AddToNewSetlistModal from '../../components/AddToNewSetlistModal';
import AddToSetlistModal  from '../../components/AddToSetlistModal';
import SongDetailsModal from '../../components/SongDetailsModal'
import { selectUser } from '../../features/auth/authSlice';
import LyricsModal from '../../components/LyricsModal';
import OfflineModal from '../../components/OfflineModal';

// pgw 16-jul-2025 - attempt to fix setlist bug
import { store, persistor } from '../../store';

import { logToIndexedDB, getLogsFromIndexedDB, clearLogsFromIndexedDB } from '../../indexedLogger';


// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';


// pgw 01-oct-2025
import localforage from 'localforage';

// pgw 28-jan-2026
import { selectLibrarySongSettingsById } from '../../features/songSettings/songSettingsSlice';


// Create a shared instance (only once)
const audioAssetStore = localforage.createInstance({
  name: 'multitrackPlayer',
  version: 1.0,
  storeName: 'audio_assets_store',
  description: 'Asset storage for the multitrackPlayer application'
});



// pgw 02-oct-2025
async function isReallyOnline3(timeoutMs = 2000) {
	debugLog('isReallyOnline3 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	debugLog('isReallyOnline3 p2')
    return res.ok;
  } catch {
	debugLog('isReallyOnline3 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}

async function isReallyOnline4(timeoutMs = 2000) {
	debugLog('isReallyOnline4 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	debugLog('isReallyOnline4 p2')
    return res.ok;
  } catch {
	debugLog('isReallyOnline4 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}

async function isReallyOnline5(timeoutMs = 2000) {
	debugLog('isReallyOnline5 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	debugLog('isReallyOnline5 p2')
    return res.ok;
  } catch {
	debugLog('isReallyOnline5 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}




// Define reusable function
async function checkAudioAsset(url) {

		debugLog("checkAudioAsset p1 url = ", url);

  try {

		debugLog("checkAudioAsset p2 url = ", url);

		// pgw 19-oct-2025
		// console.log("19-oct-2025 checkAudioAsset p2 url = ", url);

    await audioAssetStore.ready();

		debugLog("checkAudioAsset p3 url = ", url);

    const value = await audioAssetStore.getItem(url);

		debugLog("checkAudioAsset p4 value = ", value);

		// pgw 19-oct-2025
		// console.log("19-oct-2025 checkAudioAsset p4 value = ", value);

    if (value !== null && value !== undefined) {
      debugLog(`Found entry in audio_assets_store for:`, url);
      return true;
    } else {
      debugLog(`No entry found in audio_assets_store for:`, url);
      return false;
    }
  } catch (err) {
    console.error("Error checking audio asset:", err);
    return false;
  }
}



// pgw 16-jul-2025 - attempt to fix setlist bug
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export const DEBUG_LOG_KEY = 'debugLogs';


export const logToLocalStorage = (message, payload = null) => {
	const logs = JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
	const timestamp = new Date().toISOString();

	const now = new Date();
	const ukTimeWithSeconds = now.toLocaleTimeString('en-GB', {
	  hour: '2-digit',
	  minute: '2-digit',
	  second: '2-digit',
	  timeZone: 'Europe/London',
	  hour12: false
	});

	let msg = `${ukTimeWithSeconds}`;


	if (payload) {
		msg = msg + ` m=${message} p=${payload}`
// 		logs.push({ message, payload });
		logs.push(msg);
	}
	else {

		msg = msg + ` m=${message}`
		logs.push(msg);
// 		logs.push(message);
	}
	// 	logs.push({ timestamp, message, payload });
	debugLog("message = ", message)
	localStorage.setItem(DEBUG_LOG_KEY, JSON.stringify(logs));
};


export const getLogsFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
};

export const clearLogs = () => {
  localStorage.removeItem(DEBUG_LOG_KEY);
};



export function logAllSetlists(state) {

debugLog('logAllSetlists 1')
	  logToIndexedDB('logAllSetlists 1');

	try {

// 	  logToIndexedDB('logAllSetlists 2 state = ', state);
// 	  debugLog('logAllSetlists 2 state = ', state);

	  const setlistsObj = state.setlists;
	  const setlists = setlistsObj.setlists;

	  logToIndexedDB('App Current setlists');
	  setlists.forEach(sl => {
		logToIndexedDB('App sl.title = ', sl.title);
		sl.items.forEach(song => {
			logToIndexedDB('App song.mix = ', song.mix);
		});
	  });
	}
	catch(e) {
  		logToIndexedDB('App logAllSetlists, e = ', e);
  		logToIndexedDB(e);
  		debugLog('App logAllSetlists, e = ', e);
	}
}





function isObject(object) {
    return object != null && typeof object === 'object';
  }
  
  function deepEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = isObject(val1) && isObject(val2);
      if (
        areObjects && !deepEqual(val1, val2) ||
        !areObjects && val1 !== val2
      ) {
        return false;
      }
    }
    return true;
  }



function waitForReply(port1, timeoutMs = 5000) {
  return new Promise((resolve, reject) => {
    let settled = false;

    // normal reply
    port1.onmessage = (e) => {
      if (!settled) {
        settled = true;
        debugLog("[isUrlCachedViaSW] got reply:", e.data);
        resolve(e.data);
      }
    };

    // error from the port
    port1.onerror = (err) => {
      if (!settled) {
        settled = true;
        console.error("[isUrlCachedViaSW] port error:", err);
        reject(err);
      }
    };

    // timeout fallback
    setTimeout(() => {
      if (!settled) {
        settled = true;
        console.error("[isUrlCachedViaSW] timeout waiting for reply");
        reject(new Error("timeout waiting for SW reply"));
      }
    }, timeoutMs);
  });
}


async function isUrlCachedViaSW(url, timeoutMs = 20000) {

	debugLog("isUrlCachedViaSW p1 url = ", url )

  const sw = navigator.serviceWorker?.controller || (await navigator.serviceWorker.ready).active;
  if (!sw) {
    console.warn('[isUrlCachedViaSW] no active service worker/controller');
    return { found: false, reason: 'no-controller' };
  }

  const { port1, port2 } = new MessageChannel();

  let settled = false;
  let timer;

	debugLog("isUrlCachedViaSW p2 url = ", url )

  const reply = new Promise((resolve, reject) => {
    // timeout: reject if SW never replies
    timer = setTimeout(() => {
        debugLog('isUrlCachedViaSW setTimeout, settled = ', settled);
      if (!settled) {
        settled = true;
        console.error('[isUrlCachedViaSW] timeout waiting for SW reply');
        reject(new Error('timeout waiting for SW reply'));
      }
    }, timeoutMs);

    port1.onmessage = (e) => {
        debugLog('isUrlCachedViaSW onmessage, e = ', e);
        debugLog('isUrlCachedViaSW onmessage, e.data = ', e.data);
        debugLog('isUrlCachedViaSW onmessage, settled = ', settled);
      if (!settled) {
        settled = true;
        clearTimeout(timer);
        debugLog('isUrlCachedViaSW p5a');
        resolve(e.data); // expect {found:boolean, cacheName?:string}
      }
    };

    port1.onerror = (err) => {
         debugLog('isUrlCachedViaSW onerror, err = ', err);
        debugLog('isUrlCachedViaSW onerror, settled = ', settled);
     if (!settled) {
        settled = true;
        clearTimeout(timer);
        console.error('[isUrlCachedViaSW] MessagePort error:', err);
        reject(err instanceof Error ? err : new Error('MessagePort error'));
      }
    };
  });

  debugLog('isUrlCachedViaSW p5a');

  try {
         debugLog('isUrlCachedViaSW  before sw.postMessage');
    sw.postMessage({ type: 'IS_URL_CACHED', url }, [port2]);
         debugLog('isUrlCachedViaSW  after sw.postMessage');
  } catch (e) {
         debugLog('isUrlCachedViaSW  e = ', e);
    // postMessage itself can throw if the SW died between ready and now
    clearTimeout(timer);
    console.error('[isUrlCachedViaSW] postMessage failed:', e);
    return { found: false, reason: 'postMessage-failed', error: String(e) };
  }

  debugLog('isUrlCachedViaSW p6');

  try {
    const res = await reply;
    debugLog('isUrlCachedViaSW p7 res =', res);
    return res; // {found: boolean, cacheName?: string}
  } catch (e) {
    console.error('[isUrlCachedViaSW] reply failed:', e);
    return { found: false, reason: 'no-reply', error: String(e) };
  }
}



async function isUrlCachedViaSWold(url) {

	debugLog("isUrlCachedViaSW p1 url = ", url )


  if (!navigator.serviceWorker?.controller) {
	debugLog("isUrlCachedViaSW p2 page not controlled yet - before await navigator.serviceWorker.ready" )
    // page not controlled yet
    await navigator.serviceWorker.ready;

	debugLog("isUrlCachedViaSW p2 page not controlled yet - after await navigator.serviceWorker.ready" )

  }

	debugLog("isUrlCachedViaSW p3" )

  const sw = navigator.serviceWorker.controller;

	debugLog("isUrlCachedViaSW p3" )

  if (!sw) {
	debugLog("isUrlCachedViaSW p4 !sw - returnng" )
	return { found: false, reason: 'no-controller' };
  }

	debugLog("isUrlCachedViaSW p5" )

  const { port1, port2 } = new MessageChannel();

  const reply = new Promise(resolve => {
    port1.onmessage = (e) => {
		debugLog("isUrlCachedViaSW p5a" )
		resolve(e.data);
	}
  });


	debugLog("isUrlCachedViaSW p5a" )

  sw.postMessage({ type: 'IS_URL_CACHED', url }, [port2]);

	debugLog("isUrlCachedViaSW p6" )
	let res = await reply;
	debugLog("isUrlCachedViaSW p7 res = ", res )

  return res; // {found: boolean, cacheName?: string}
}


async function isKeyInAnyCache(urlFragment) {
  if (!('caches' in window)) {
    console.warn("Cache API not supported in this context.");
    return false;
  }

  const cacheNames = await caches.keys();
  debugLog("🔍 Checking caches:", cacheNames);

  for (const name of cacheNames) {
    const cache = await caches.open(name);
    const requests = await cache.keys();

    for (const req of requests) {
  		debugLog("req.url = ", req.url);
  		debugLog("urlFragment = ", urlFragment);
      if (req.url == urlFragment) {
        debugLog(`Found in cache "${name}": ${req.url}`);
        return true;
      }
    }
  }

  debugLog("Not found in any cache:", urlFragment);
  return false;
}






const songShowLimit = 600;
const LibraryContainer = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const librarySongs = useSelector(selectLibrarySongs);

	// pgw 28-jan-2026
	const librarySongSettingsById = useSelector(selectLibrarySongSettingsById);

    const libraryStatus = useSelector(selectLibraryStatus);
    const sessions = useSelector(selectSetlistSessions);
    const setlistSessions = useSelector(selectSetlistSessions);
    const lastCreatedSessionInSetlist = useSelector(selectLastCreatedSession);
    const clientConfiguration = useSelector(selectClientConfig);
    const currentLyrics = useSelector(selectLyricsLyrics);
    const lyricsStatus = useSelector(selectLyricsStatus);
    const currentUser = useSelector(selectUser);
    const offlineModalVisible = useSelector(selectOfflineModalVisible);
    const setlists = useSelector(selectSetlistsSetlists);
    
    const [genres, setGenres] = useState([]);
    const [keySignatures, setKeySignatures] = useState([]);
    const [decades, setDecades] = useState([]);
    const [search, setSearch] = useState('');

    
    const [pendingSongSelection, setPendingSongSelection] = useState(null);
    const [pendingNewSetlist, setPendingNewSetlist] = useState(false);
    const [pendingAddToPlaylist, setPendingAddToPlaylist] = useState(false);

    const [lyricsPreview, setLyricsPreview] = useState(null);

    const lastRequestConfig = useRef({});

    const [activeFilters, setActiveFilters] = useState({
        genres: [],
        decades: [],
        keySignatures: []
    });

    useEffect(()=>{
		console.log("[CONTAINERS_LIBRARY_INDEX] calling dispatch(resetLastCreated()) 1")
		// pgw 19-jan-2025
        debugLog('pgw aaa_2 pgw2_5 - p1')

        dispatch(resetLastCreated());
        const requestConfig = {startIndex: 0, limit: songShowLimit};
        // if (!deepEqual(requestConfig, lastRequestConfig.current)) dispatch(fetchLibrarySongsAsync(requestConfig)); 
        lastRequestConfig.current = requestConfig;
    },[]);

    useEffect(()=>{
        dispatch(resetLyrics())
        if (pendingSongSelection?.lyricsUrl) dispatch(fetchLyricsAsync(pendingSongSelection.lyricsUrl))
    }, [pendingSongSelection, dispatch]);

    useEffect(()=>{
        setGenres([...new Set(librarySongs.map(song => song.genre))]);
        setKeySignatures([...new Set(librarySongs.map(song => song.key))]);
        setDecades([...new Set(librarySongs.map(song => song.decade))]);
    }, [librarySongs]);

    const selectSong = async (songId) => {

		// pgw 16-aug-2025
		debugLog("selectSong songId = ", songId )

        const song = librarySongs.find(s => s.songId === songId);


		debugLog("selectSong song.mix = ", song.mix )
		debugLog("selectSong song.artist = ", song.artist )
		debugLog("selectSong song.pathzip = ", song.pathzip )

		  debugLog("aa1 async");
		  try {
			const isCached = await checkAudioAsset(song.pathzip);
			debugLog("aa2 async isCached =", isCached);

			// pgw 19-oct-2025
			// console.log("19-oct-2025 async isCached =", isCached);

			if (isCached) {
			  debugLog("song is in cache");
			} else {
			  debugLog("song is NOT in cache");

			  // pgw 02-oct-2025
			  const ok = await isReallyOnline3(2500);
			  if (!ok) {
				// behave as offline for this operation
			  	// alert('Song is not in cache, so it will not work if you are offline…');

				let res = confirm("You are offline\nand this song is not in a setlist set to work offline.\nAre you sure you want to continue ?\n(OK to continue; Cancel to do nothing.) ?")
				debugLog('res = ', res);
				if (res) {
					debugLog("You pressed OK!");
				} else {
					debugLog("You pressed Cancel - returning...");
					return;
				}



			  }

			}
		  } catch (e) {
			console.error("cache check failed:", e);
		  }

		if (false) {
			let r1
			let r2
			  debugLog("aa1 async ");


			r1 = (async () => {


				try {
					debugLog("c2 async ");
					debugLog("async c3" )

					let r2 = await checkAudioAsset(song.pathzip)
					debugLog("c4 async" )
					debugLog("c5 async res1 = ", r2 )

					debugLog("c6 async ");
				}
				catch(e) {
					debugLog("c6 async e = ", e);
				}
			})();

	// 
	// 
	// 		r1 = (async () => {
	// 		  debugLog("aa2 async ");
	// 			r2 = await checkAudioAsset(song.pathzip)
	// 		  debugLog("aa2 async r2 = ", r2);
	// 		})();

			debugLog("aa3 async r1 = ", r1);
			debugLog("aa3 async r2 = ", r2);
			debugLog("aa3 async ");

			// async function checkAudioAsset(url) {



			if (r2) {
				debugLog("aa4 async song is in cache");
			}
			else {
				debugLog("aa4 async song is NOT in cache");
				// alert('Song is not in cache, so it will not work if you are offline...')

				let res = confirm("You are offline\nand this song is not in a setlist set to work offline.\nAre you sure you want to continue ?\n(OK to continue; Cancel to do nothing..) ?")
				debugLog('res = ', res);
				if (res) {
					debugLog("You pressed OK!");
				} else {
					debugLog("You pressed Cancel - returning...");
					return;
				}

			}

		}
		if (false) {
			let l1
			  debugLog("a1 async ");

			l1 = (async () => {
			  debugLog("a2 async ");
			})();

			debugLog("async l1 = ", l1);
			debugLog("a3 async ");

			debugLog("b1 async ");
			l1 = (async () => {
			  debugLog("b2 async ");
				debugLog("async b3 test " )
			  debugLog("b4 async ");
			})();

			debugLog("async l1 = ", l1);
			debugLog("b5 async ");



			debugLog("c1 async ");
			l1 = (async () => {


				try {
					debugLog("c2 async ");
					debugLog("async c3" )

					let res1 = await isUrlCachedViaSW(song.pathzip)
					debugLog("c4 async" )
					debugLog("c5 async res1 = ", res1 )

					debugLog("c6 async ");
				}
				catch(e) {
					debugLog("c6 async e = ", e);
				}
			})();

			debugLog("async l1 = ", l1);
			debugLog("c7 async ");




			  debugLog("p1 async before async");

			l1 = (async () => {
			  debugLog("p2 async ");



				// Usage:
				let res1



				res1 = await isKeyInAnyCache(song.pathzip)
				debugLog("selectSong isKeyInAnyCache song.pathzip  = ", song.pathzip )
				debugLog("selectSong isKeyInAnyCache song.pathzip res1 = ", res1 )

				res1 = await isKeyInAnyCache("https://3firetrackmanager.s3.amazonaws.com/com.3firemusic.choirplayer.000064/111.zip")
				debugLog("selectSong isKeyInAnyCache https://3firetrackmanager.s3.amazonaws.com/com.3firemusic.choirplayer.000064/111.zip res1 = ", res1 )


				res1 = await isKeyInAnyCache("https://devplayer.choirplayer.com/fallback/song_list_choir_genius.json")
				debugLog("selectSong isKeyInAnyCache https://devplayer.choirplayer.com/fallback/song_list_choir_genius.json res1 = ", res1 )


				res1 = await isUrlCachedViaSW("https://3firetrackmanager.s3.amazonaws.com/com.3firemusic.choirplayer.000064/111.zip")
				debugLog("selectSong isUrlCachedViaSW https://3firetrackmanager.s3.amazonaws.com/com.3firemusic.choirplayer.000064/111.zip res1 = ", res1 )


				res1 = await isUrlCachedViaSW("https://devplayer.choirplayer.com/fallback/song_list_choir_genius.json")
				debugLog("selectSong isUrlCachedViaSW https://devplayer.choirplayer.com/fallback/song_list_choir_genius.json res1 = ", res1 )

				res1 = await isUrlCachedViaSW("/fallback/song_list_choir_genius.json")
				debugLog("selectSong isUrlCachedViaSW /fallback/song_list_choir_genius.json res1 = ", res1 )

				res1 = await isUrlCachedViaSW("fallback/song_list_choir_genius.json")
				debugLog("selectSong isUrlCachedViaSW fallback/song_list_choir_genius.json res1 = ", res1 )

				res1 = await isUrlCachedViaSW("https://devplayer.choirplayer.com/persist_root_1.html")
				debugLog("selectSong isUrlCachedViaSW https://devplayer.choirplayer.com/persist_root_1.html res1 = ", res1 )

				res1 = await isUrlCachedViaSW("/persist_root_1.html")
				debugLog("selectSong isUrlCachedViaSW /persist_root_1.html res1 = ", res1 )

				res1 = await isUrlCachedViaSW("persist_root_1.html")
				debugLog("selectSong isUrlCachedViaSW persist_root_1.html res1 = ", res1 )

				res1 = await isUrlCachedViaSW("/images/choir-player/login-splash.jpeg")
				debugLog("selectSong isUrlCachedViaSW /images/choir-player/login-splash.jpeg res1 = ", res1 )

				res1 = await isUrlCachedViaSW("https://devplayer.choirplayer.com/images/choir-player/login-splash.jpeg")
				debugLog("selectSong isUrlCachedViaSW https://devplayer.choirplayer.com/images/choir-player/login-splash.jpeg res1 = ", res1 )

				res1 = await isUrlCachedViaSW("choirplayer_lyrics/com.3firemusic.choirplayer.000064_lyrics.json")
				debugLog("selectSong isUrlCachedViaSW choirplayer_lyrics/com.3firemusic.choirplayer.000064_lyrics.json res1 = ", res1 )

				res1 = await isUrlCachedViaSW("/choirplayer_lyrics/com.3firemusic.choirplayer.000064_lyrics.json")
				debugLog("selectSong isUrlCachedViaSW /choirplayer_lyrics/com.3firemusic.choirplayer.000064_lyrics.json res1 = ", res1 )

	

				res1 = await isUrlCachedViaSW(song.pathzip)
				debugLog("selectSong isUrlCachedViaSW song.pathzip res1 = ", res1 )

				res1 = await isUrlCachedViaSW("/clear2.html")
				debugLog("selectSong isUrlCachedViaSW /clear2.html res1 = ", res1 )

				res1 = await isUrlCachedViaSW("/images/choir-player/choirplayer-logo-pink.svg")
				debugLog("selectSong isUrlCachedViaSW /images/choir-player/choirplayer-logo-pink.svg	 res1 = ", res1 )

				res1 = await isUrlCachedViaSW("https://devplayer.choirplayer.com/images/choir-player/choirplayer-logo-pink.svg")
				debugLog("selectSong isUrlCachedViaSW https://devplayer.choirplayer.com/images/choir-player/choirplayer-logo-pink.svg res1 = ", res1 )
			  debugLog("p3 async ");

			})();

			debugLog("async l1 = ", l1);
			  debugLog("p4 async ");


		}

		debugLog("selectSong currentUser?.subscribed = ", currentUser?.subscribed )
		debugLog("selectSong clientConfiguration.features.library.limitedLibrary.includes(songId) = ", clientConfiguration.features.library.limitedLibrary.includes(songId) )

        if (!currentUser?.subscribed && clientConfiguration.features.library.limitedLibrary.includes(songId)) {

			debugLog("selectSong user is not subscribed && limitedLibrary includes song -  callng handleOpenSong ", )

			// pgw 25-jan-2206
			console.log("[CONTAINERS_LIBRARY_INDEX] selectSong user is not subscribed && limitedLibrary includes song")
			console.log("[CONTAINERS_LIBRARY_INDEX] calling handleOpenSong, songId = ", songId)


			// pgw 28-jan-2206
            // handleOpenSong(songId)
			handleOpenSong(songId, { origin: "library" })
        } else {

			debugLog("selectSong clientConfiguration alwaysAddSongToMyPlaylist = ", clientConfiguration.features.library.alwaysAddSongToMyPlaylist)

            if (clientConfiguration.features.library.alwaysAddSongToMyPlaylist) {

				debugLog("selectSong calling dispatch(createSessionFromSong...) ")

				console.log("[CONTAINERS_LIBRARY_INDEX] dispatching createSessionFromSong", createSessionFromSong.type);

				console.log("[CONTAINERS_LIBRARY_INDEX] about to create session", { songId, hasSong: !!song, songMix: song?.mix });

				const restoreSettings = librarySongSettingsById?.[songId] || null;

				console.log("[LIB OPEN] passing restoreSettings", {
				  songId,
				  hasRestoreSettings: !!restoreSettings,
				  restoreStems: restoreSettings?.stems?.map(s => ({ index: s.index, level: s.level }))
				});


				console.log("[LIB OPEN] restoreSettings being passed", {
				  speed: restoreSettings?.speed,
				  pitch: restoreSettings?.pitch,
				  stems: restoreSettings?.stems?.map(s => ({ index: s.index, level: s.level })),
				});


				dispatch(createSessionFromSong({
				  songId,
				  restoreSettings,   // ✅ must be included
				}));


				// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
				/*
                dispatch(addNotificationAsync({
                    title: 'Song added',
                    text: `${song.mix} by ${song.artist} added to your setlist`,
                    type: 'positive',
                }))
				*/

				// pgw 29-sep-2025
				debugLog('player-application/src/containers/Library/index.js selectSong navigating to /setlist');
                navigate(`/setlist`);
            } else {
				debugLog("selectSong calling setPendingSongSelection(song)")
                setPendingSongSelection(song);
            }   
        }
    }



    const handleAddToSetlist = (setlist) => {


		debugLog('handleAddToSetlist p0, setlist = ', setlist)
		debugLog('handleAddToSetlist p0, setlist.title = ', setlist.title)
		debugLog('handleAddToSetlist p0, setlist.subTitle = ', setlist.subTitle)
		debugLog('handleAddToSetlist p0, setlist.id = ', setlist.id)
		debugLog('handleAddToSetlist p0, setlist.cached = ', setlist.cached)
		debugLog('handleAddToSetlist p0, setlist.readOnly = ', setlist.readOnly)
		debugLog('handleAddToSetlist p0, setlist.items = ', setlist.items)



// 	const handleAddToSetlist = async (setlist) => {


		try {
			// log the current setlists
			let state = store.getState();
// 			logToIndexedDB('handleAddToSetlist p1, state = ', state)
			logToIndexedDB('handleAddToSetlist p1')
			logAllSetlists(state);
			logToIndexedDB('handleAddToSetlist p2')
		}
		catch(e) {
			logToIndexedDB('handleAddToSetlist p1, e = ', e)
		}


		debugLog('handleAddToSetlist p1 before dispatch(addSongToSetlist), pendingSongSelection = ', pendingSongSelection)


		// pgw 06-feb-2026

		// Build setlist item settings from current library-scoped settings (if any)
		const songId = pendingSongSelection?.songId;
		const librarySettingsForSong = songId ? (librarySongSettingsById?.[songId] || null) : null;

		const songForSetlist = {
		  ...pendingSongSelection,
		  // Only seed itemSettings if not already present on the song object
		  itemSettings: pendingSongSelection?.itemSettings ?? librarySettingsForSong,
		};

		console.log("[LIB->SETLIST] adding song with seeded itemSettings", {
		  setlistId: setlist?.id,
		  songId,
		  hasLibrarySettings: !!librarySettingsForSong,
		  hasItemSettingsOnSong: !!pendingSongSelection?.itemSettings,
		  applied: !!songForSetlist?.itemSettings,
		  stems: songForSetlist?.itemSettings?.stems?.map(s => ({ index: s.index, level: s.level })),
		  speed: songForSetlist?.itemSettings?.speed,
		  pitch: songForSetlist?.itemSettings?.pitch,
		});

		dispatch(addSongToSetlist({
		  setlistId: setlist.id,
		  song: songForSetlist
		}));



		/*
        dispatch(addSongToSetlist({
            setlistId: setlist.id,
            song: pendingSongSelection
        }));
		*/

		// pgw 16-jul-2025 - attempt to fix setlist bug
		debugLog('handleAddToSetlist p1')

		/*
		await sleep(100);

		debugLog('handleAddToSetlist p2')
		persistor.flush();

		await sleep(100);
		debugLog('handleAddToSetlist p3')
		*/

		// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
		/*
        dispatch(addNotificationAsync({
            title: null,
            text:<p><b>{pendingSongSelection.mix}</b> added to <b>{setlist.name}</b>.</p>,
            type: "positive",
        }));
		*/

        setPendingSongSelection(null)
        setPendingAddToPlaylist(false)
    }


    const renderEmptySetlistInfo = () => {
        if (clientConfiguration.features.setlist.enabled) {
            return <div className="p-2">
                <Alert alertType="info" dismissible={false}><span>Get started by adding songs to <Link className="text-primary" to="/setlist">Your Setlist</Link> below.</span></Alert>
            </div>
        } 
        return null;
    }

    const renderLoading = () => {
        return <div className="p-2 flex justify-center">
       <Spinner />
    </div>
    }

    const fetchSongs = async  (limit, search) => {

		// pgw testing 19-jan-2024
		// pgw testing 19-jan-2025
        debugLog('pgw fetchsongs pgw2_5 - p1');
        

        let result;
        if (search) {
            const requestConfig = {startIndex: 0, limit, search };
            if (!deepEqual(requestConfig, lastRequestConfig.current)) result = await dispatch(fetchLibrarySongsAsync(requestConfig)); 
            lastRequestConfig.current = requestConfig;
        } else {
            const requestConfig = {startIndex: 0, limit };
            if (!deepEqual(requestConfig, lastRequestConfig.current)) result = await dispatch(fetchLibrarySongsAsync(requestConfig));
            lastRequestConfig.current = requestConfig;
        }
        if (result?.error) {
        	debugLog('pgw fetchSongs error');
        	console.trace('fetchSongs error');
            dispatch(setOfflineModalVisible(true));
        }    
    }

    useEffect(()=>{
        if (search) {
            fetchSongs(songShowLimit, search.toLowerCase())
        } else {
            fetchSongs(songShowLimit)
        }
    }, [dispatch, search]);

    useEffect(()=>{
        debugLog('pgw active filters');
        const requestConfig = {startIndex: 0, limit: songShowLimit, activeFilters};
        if (!deepEqual(requestConfig, lastRequestConfig.current)) dispatch(fetchLibrarySongsAsync(requestConfig));
        lastRequestConfig.current = requestConfig;
    }, [activeFilters])

    const isSongSupported = (songId) => {
        if ( clientConfiguration.logic.restrictedDevices.includes(platform.product) && !clientConfiguration.features.library.songsWorkingOnIos.includes(songId)) {
            return false;
        } else if (platform.os?.family === 'OS X' && navigator.maxTouchPoints) { // is iPad
            if (!clientConfiguration.features.library.songsWorkingOnIos.includes(songId)) {
                return false;
            }
        }
        return true;
        
    }

    const renderNotSupported = () => {
        return <div className="flex items-center"><ExclamationIcon className="h-4 w-4 mr-1 text-primary" /><span className="text-sm">Not supported</span></div>
    }

    const shouldEnableSong = (songId) => {
        if (currentUser?.subscribed) return true;
        if (clientConfiguration.features.library.limitedLibrary.includes(songId)) return true
        return false;
    }


	// pgw 28-jan-2026
	const handleOpenSong = async (songId) => {

	  console.log("[CONTAINERS_LIBRARY_INDEX] in handleOpenSong, songId = ", songId);

	  if (typeof songId !== "string") {
		console.log("[CONTAINERS_LIBRARY_INDEX] handleOpenSong called with non-string songId", songId);
		return;
	  }


	  // pgw 25-jan-2206
	  console.log("[CONTAINERS_LIBRARY_INDEX] in handleOpenSong, songId = ", songId);


	  if (libraryStatus !== 'idle') {
		console.log("[CONTAINERS_LIBRARY_INDEX] handleOpenSong blocked - libraryStatus =", libraryStatus);
		return;
	  }

	  const song = librarySongs.find(s => s.songId === songId);
	  if (!song) {
		console.warn("[CONTAINERS_LIBRARY_INDEX] handleOpenSong - song not found", {
		  songId,
		  librarySongsLen: librarySongs?.length
		});
		return;
	  }


	  // NEW: library-scoped settings (per songId)
	  // Assumes you have something like: const librarySongSettingsById = useSelector(selectLibrarySongSettingsById);
	  // If you haven't implemented this yet, keep restoreSettings = null for now.
	  const restoreSettings = librarySongSettingsById?.[songId] || null;


	  console.log("[CONTAINERS_LIBRARY_INDEX] open from library songId = ", songId);
	  console.log("[CONTAINERS_LIBRARY_INDEX] open from library restoreSettings = ", restoreSettings);
	  console.log("[CONTAINERS_LIBRARY_INDEX] open from library restoreSettings?.stems = ", restoreSettings?.stems);


	  // pgw 02-oct-2025
	  const ok = await isReallyOnline4(2500);
	  if (ok) {
		debugLog("user is online");
	  } else {
		debugLog("user is offline !!");

		// Keep your existing offline behavior (currently it's non-blocking)
		// If you later want to block opening when offline and not cached, do it here.
	  }

	  // IMPORTANT: for library-origin opens we do NOT use setlistSessions/openSession
	  // We always create a fresh session seeded with library settings.

	console.log("[CONTAINERS_LIBRARY_INDEX] dispatching createSessionFromSong", createSessionFromSong.type);
	console.log("[CONTAINERS_LIBRARY_INDEX] about to create session", { songId, hasSong: !!song, songMix: song?.mix });



		console.log("[CONTAINERS_LIBRARY_INDEX] restoreSettings lookup", {
		  songId,
		  hasStore: !!librarySongSettingsById,
		  keys: librarySongSettingsById ? Object.keys(librarySongSettingsById).slice(0, 5) : null,
		  hasRestoreSettings: !!restoreSettings,
		  restoreStems: restoreSettings?.stems?.map(s => `${s.id}:${s.level}`)
		});



		console.log("[CONTAINERS_LIBRARY_INDEX] createSessionFromSong.type =", createSessionFromSong.type);

		await dispatch(createSessionFromSong({
		  song,
		  title: song.mix,
		  origin: { type: "library", songId },
		  restoreSettings
		}));

		const stateNow = store.getState();
		const newId = stateNow.setlist?.lastCreatedSession;
		const created = stateNow.setlist?.sessions?.find(s => s.id === newId);

		console.log("[LIB OPEN] created session lookup", {
		  newId,
		  found: !!created,
		  stems: created?.stems?.map(s => ({ id: s.id, level: s.level })),
		});

		if (created) {
		  await dispatch(openSession(created));

		  console.log("[CONTAINERS_LIBRARY_INDEX] calling dispatch(resetLastCreated()) 2")
		  dispatch(resetLastCreated());

		} else {
		  console.warn("[LIB OPEN] could not find created session to open", { newId });
		}

		navigate("/session");
	};


    const handleSubscribe = async () => {

		// pgw 07-oct-2025
		const ok = await isReallyOnline5(2500);
		if (ok) {
			debugLog('user is online')
		}
		else {
			debugLog('user is offline !!')

			let confStr = "You are offline !"
			confStr = confStr + "\n" + "It is not possible to subscribe while you are offline."
			confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
			confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"

			let res = confirm(confStr)
			if (res) {
				debugLog("You pressed OK!");
			} else {
				debugLog("You pressed Cancel - returning...");
				return;
			}

		}

        window.open(clientConfiguration.features.library.subscribeConfig.url);
    }

    const handleViewLyrics = () => {
        setLyricsPreview(true);
    }

    const handleAddSongToSetlist = () => {
        setPendingAddToPlaylist(true);
        if (setlists.length === 0) setPendingNewSetlist(true);
    }

	// pgw 18-jul-2025
	const waitForPersist = async (delayMs = 50) => {

		debugLog('waitForPersist p1')
		try {
		  await new Promise(resolve => setTimeout(resolve, delayMs));
			debugLog('waitForPersist p2')
		  await persistor.flush();
			debugLog('waitForPersist p3')
		}
		catch(e) {
			debugLog('waitForPersist p1 e = ', e)
		}

	};


		// pgw 18-jul-2025 change to async

//      const handleAddToNewSetlist = ({title, subtitle, imageUrl}) => {
const handleAddToNewSetlist = async ({title, subtitle, imageUrl}) => {


		// pgw 18-jul-2025
		debugLog('handleAddToNewSetlist p1 title = ', title)

        dispatch(createSetlistFromData({title, subtitle, imageUrl, items: [pendingSongSelection]}));
		
		// pgw 18-jul-2025
		debugLog('handleAddToNewSetlist p2 before waitForPersist')
		await waitForPersist();
		debugLog('handleAddToNewSetlist p2 after waitForPersist')




		// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
        /*
		dispatch(addNotificationAsync({
            title: null,
            text:<p><b>{pendingSongSelection.mix}</b> added to new <b>{title}</b> setlist.</p>,
            type: "positive",
        }));
		*/

		debugLog('handleAddToNewSetlist p1')

		// pgw 16-jul-2025 - attempt to fix setlist bug
		/*
		debugLog('handleAddToNewSetlist p1')
		await sleep(100);

		debugLog('handleAddToNewSetlist p2')
		persistor.flush();

		await sleep(100);
		debugLog('handleAddToNewSetlist p3')
		*/

        setPendingNewSetlist(false);
        setPendingAddToPlaylist(false);
        setPendingSongSelection(null);
    }

    const mapSongToSongItem = (song) => {
        return {
            id: song.songId,
            // title: <>  <span>{song.mix}</span> {!isSongSupported(song.songId) ? renderNotSupported() : null} </>,
            title: song.mix,
            artist: song.artist,
            genre: song.genre,
            decade: song.decade,
            key: song.key,
            time: song.len,
            state: setlistSessions.find(s => s.song.mix === song.mix) ? "IN_SETLIST": "NOT_IN_SETLIST",
            onSelected: ()=> selectSong(song.songId),
            showActionButton: false,
            actionLabel: <></>
        }
    }

    const formSongsList = () => {
        const songs = librarySongs.map(song => mapSongToSongItem(song)).sort((a, b) => a.title.localeCompare(b.title));
        if (currentUser?.subscribed) {
            return songs;
        } else {
            return songs.filter(song => !shouldEnableSong(song.songId));
        }
    }

    const handleOpenSheetMusic = (url) => {
        window.open(url, "_blank");
    }

    return <>
        {(libraryStatus === 'idle' && setlistSessions.length === 0) && renderEmptySetlistInfo() }
        {(!search && libraryStatus === 'pending') && renderLoading()}
        {<Library 
            genres={genres}
            keySignatures={keySignatures}
            decades={decades}
            onFilterChanged={setActiveFilters}
            searchValue={search}
            onSearchChanged={(e)=>setSearch(e.target.value)}
            items={formSongsList().filter(song => currentUser?.subscribed? true : !clientConfiguration.features.library.limitedLibrary.includes(song.id))} 

            promotionalItems={currentUser?.subscribed ? []: formSongsList().filter(song => clientConfiguration.features.library.limitedLibrary.includes(song.id))}
            promotionalImageUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.registrationPromo}`}
            promotionalLinkText={clientConfiguration.features.library.subscribeConfig.libraryPromoText}
            promotionalLinkButtonText={clientConfiguration.features.library.subscribeConfig.libraryPromoButtonText}
            promotionalLinkUrl={clientConfiguration.features.library.subscribeConfig.url}
            promotionalText={clientConfiguration.features.library.subscribeConfig.libraryText}
            promotionalTitle={clientConfiguration.features.library.subscribeConfig.libraryTitle}
            sortedBy={{
                "label": "Title",
                "dir": "desc"
            }} 
        />}
        
        <SongDetailsModal 
            onOpenSheetMusic={handleOpenSheetMusic} 
            song={pendingSongSelection} 
            lyrics={currentLyrics} 
            lyricsStatus={lyricsStatus} 
            subscribeConfig={clientConfiguration.features.library.subscribeConfig} 
            restricted={pendingSongSelection && !shouldEnableSong(pendingSongSelection.songId)} 
            isOpen={!!pendingSongSelection && !pendingAddToPlaylist && !lyricsPreview} 
            onClose={()=>setPendingSongSelection(null)} 
            // onOpen={handleOpenSong} 
			// pgw 26-jan-2026

			/*
			onOpen={(...args) => {
			  console.log("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen called, args = ", args);

			  // Common cases:
			  // 1) onOpen(songId: string)
			  // 2) onOpen(song: { songId, ... })
			  // 3) onOpen(event, songId) or similar

			  const a0 = args[0];
			  const a1 = args[1];

			  const derivedSongId =
				(typeof a0 === "string" && a0) ? a0 :
				(a0 && typeof a0 === "object" && typeof a0.songId === "string") ? a0.songId :
				(typeof a1 === "string" && a1) ? a1 :
				(a1 && typeof a1 === "object" && typeof a1.songId === "string") ? a1.songId :
				null;

			  if (!derivedSongId) {
				console.warn("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen: could not derive songId", args);
				return;
			  }

			  console.log("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen derivedSongId = ", derivedSongId);
			  handleOpenSong(derivedSongId);
			}}
			*/

			onOpen={(...args) => {
			  console.log("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen called, args = ", args);

			  const a0 = args[0];
			  const songId =
				(typeof a0 === "string" && a0) ? a0 :
				(a0 && typeof a0 === "object" && typeof a0.songId === "string") ? a0.songId :
				null;

			  if (!songId) {
				console.warn("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen: could not derive songId", args);
				return;
			  }

			  console.log("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen derived songId =", songId);
			  handleOpenSong(songId);
			}}

			/*
			onOpen={(...args) => {
			  console.log("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen called, args = ", args);
			  console.log("[CONTAINERS_LIBRARY_INDEX] SongDetailsModal onOpen called - calling handleOpenSong...");
			  handleOpenSong(...args);
			}}
			*/

            onSubscribe={handleSubscribe} 
            onAddToSetlist={handleAddSongToSetlist} 
            onLyricsPreview={handleViewLyrics}
            autoPlayPreview={false}
        />
        
        <LyricsModal 
            song={pendingSongSelection} 
            lyrics={currentLyrics} 
            isOpen={!!lyricsPreview} 
            onClose={()=>setLyricsPreview(false)} 
        />
        
        <AddToSetlistModal setlists={setlists.map(setlist => ({
                id: setlist.id,
                name: setlist.title,
                avatar: setlist.imageUrl
            }))} onClose={()=>{
//             }))} onClose={async ()=>{


				// pgw 
				debugLog('AddToSetlistModal p1')
                setPendingSongSelection(null);
                setPendingAddToPlaylist(false)


				// pgw 16-jul-2025 - attempt to fix setlist bug
				debugLog('AddToSetlistModal p2')

				/*
				await sleep(100);

				debugLog('AddToSetlistModal p3')
				persistor.flush();

				await sleep(100);
				debugLog('AddToSetlistModal p4')
				*/

            }} isOpen={!!pendingAddToPlaylist && !pendingNewSetlist} onSelectNewPlaylist={()=>setPendingNewSetlist(true)} onConfirm={handleAddToSetlist} />

        <AddToNewSetlistModal 
            onClose={()=>{
			// onClose={async () => {
				debugLog('AddToNewSetlistModal p1')
                setPendingAddToPlaylist(false);
                setPendingNewSetlist(false);
                setPendingSongSelection(null);


				// pgw 16-jul-2025 - attempt to fix setlist bug
				debugLog('AddToNewSetlistModal p2')

				/*
				await sleep(100);

				debugLog('AddToNewSetlistModal p3')
				persistor.flush();

				await sleep(100);
				debugLog('AddToNewSetlistModal p4')
				*/


            }}
            firstSetlist={setlists.length === 0}
            isOpen={!!pendingAddToPlaylist && pendingNewSetlist}
            onConfirm={handleAddToNewSetlist}
        />

        
    </>
}

export default LibraryContainer;